import '../fixtures_match_list/index.css';
import { MatchCard } from '../../component';
import { View } from '../../../component';
import useGame from '../../../utilities/hooks/game';

const LiveMatchListWeb = ({ liveMatchList, onPressAddSubstitute, onPressMatchCard }: any) => {
  const { gameType } = useGame();

  return (
    <View className="match-container live_match_list">
      {liveMatchList.map((item: any) => (
        <MatchCard
          onPressMatchCard={onPressMatchCard}
          onPressAddSubstitute={onPressAddSubstitute}
          key={item._id}
          matchItem={item}
          gameType={gameType}
        />
      ))}
    </View>
  );
};

export default LiveMatchListWeb;
